import { FC } from 'react';
import { ReactComponent as IconClose } from '../../assets/img/close.svg';
import { ReactComponent as IconSearch } from './img/iconSearch.svg';

import styles from './CategoryInput.module.scss';

export interface FilterInputProps {
  type?: 'text' | 'number' | 'search';
  value: string | number;
  onChange: (value: string | number) => void;
  placeholder?: string;
  variant?: 'default' | 'compact';
  min?: number;
  max?: number;
  className?: string;
  summary?: string[];
  onDeleteSummary?: (item: string) => void;
  show?: boolean;
  hideSearchIcon?: boolean;
}

export const CategoryInput: FC<FilterInputProps> = ({
  value,
  onChange,
  placeholder,
  className,
  show,
}) => {
  const searchClass = styles.searchInput;

  const handleClearInput = () => {
    onChange('');
  };

  return (
    <div className={styles.searchWrapper}>
      {!value && <IconSearch className={styles.searchIcon} />}
      <input
        type='text'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${searchClass} ${className || ''}`}
        style={{
          paddingLeft: value ? '12px' : '40px',
          paddingRight: show ? '30px' : '12px',
        }}
      />
      {value && <IconClose className={styles.closeIcon} onClick={handleClearInput} />}
    </div>
  );
};
